/**
 * @file: useHasAnyProductAuthorizationContract.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentStoreId } from '@euler/app/flows/auth/context';
import { useAsyncStorage } from '@euler/functions/useAsyncStorage';
import { useServiceFactory } from '@euler/services/factory';
import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useRef } from 'react';

export const useHasAnyProductAuthorizationContract = () => {
  const { storeService } = useServiceFactory();
  const storeId = useCurrentStoreId();
  const [flag, setFlag] = useAsyncStorage<boolean>(
    `${storeId}_has-any-product-authorization-contract`,
    undefined,
  );
  const flagRef = useRef(flag);
  flagRef.current = flag;

  const refresh = useCallback(() => {
    if (flag === undefined || flag === true) {
      return;
    }
    storeService
      .hasAnyProductAuthorizationContract()
      .then(value => {
        if (flagRef.current !== value) {
          setFlag(value);
          flagRef.current = value;
        }
      })
      .catch(err => {
        console.error(err);
        setFlag(false);
      });
  }, [flag, setFlag, storeService]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useFocusEffect(refresh);

  return flag ?? false;
};
